import { OutboundTollingAgreementSortOption } from '@rematter/frontend-lib-api-client';

import { OutboundTollingAgreementRecord } from '../types/outboundTollingAgreement';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const outboundTollingAgreementsQueryAtom = createQueryAtomFactory(
  'production.outboundTollingAgreements',
  (params: {
    searchTerm?: string;
    processingTypeIds?: string[];
    isActive?: boolean;
    limit?: number;
    offset?: number;
    sorting?: OutboundTollingAgreementSortOption[];
  }) => ({
    outboundTollingAgreements: {
      __args: {
        filter: {
          searchTerm: params.searchTerm,
          processingTypeIds: params.processingTypeIds,
          isActive: params.isActive,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 25,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        agreementNumber: true,
        processorAccountId: true,
        processorAccount: {
          id: true,
          name: true,
          type: true,
          email: true,
          phone: true,
        },
        processingTypeId: true,
        processingType: {
          id: true,
          name: true,
        },
        effectiveDate: true,
        expirationDate: true,
        pricePerUnit: {
          amount: true,
          currencyCode: true,
        },
        priceUnit: true,
        expectedYieldPercentage: true,
        terms: true,
        isActive: true,
        facility: {
          id: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (
      data,
    ): {
      outboundTollingAgreements: OutboundTollingAgreementRecord[];
      totalCount: number;
    } => {
      if (!data?.outboundTollingAgreements?.entries) {
        return {
          outboundTollingAgreements: [],
          totalCount: 0,
        };
      }

      return {
        outboundTollingAgreements: data.outboundTollingAgreements.entries.map(
          (ta) => ({
            id: ta.id,
            agreementNumber: ta.agreementNumber,
            processorAccountId: ta.processorAccountId,
            processorAccount: ta.processorAccount
              ? {
                  id: ta.processorAccount.id,
                  name: ta.processorAccount.name,
                  type: ta.processorAccount.type,
                  email: ta.processorAccount.email,
                  phone: ta.processorAccount.phone,
                }
              : undefined,
            processingTypeId: ta.processingTypeId,
            processingTypeName: ta.processingType?.name,
            effectiveDate: ta.effectiveDate,
            expirationDate: ta.expirationDate ?? undefined,
            pricePerUnitAmount: ta.pricePerUnit?.amount
              ? Number(ta.pricePerUnit.amount)
              : undefined,
            pricePerUnitCurrency: ta.pricePerUnit?.currencyCode,
            priceUnit: ta.priceUnit ?? undefined,
            expectedYieldPercentage: ta.expectedYieldPercentage
              ? Number(ta.expectedYieldPercentage)
              : undefined,
            terms: ta.terms ?? undefined,
            isActive: ta.isActive,
            facilityId: ta.facility.id,
            createdAt: ta.timestamps.createdAt,
            updatedAt: ta.timestamps.updatedAt,
          }),
        ),
        totalCount: data.outboundTollingAgreements.page?.total ?? 0,
      };
    },
  },
);
